// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5a8c1964","455":"6cec2f06","977":"b1f13a84"}[chunkId] + ".chunk.js";
};